import './Banner.css'

function Banner() {
    return ( 
        <header className='banner'>
            <img src='/imagens/banner.png' alt='banner na página do organo'></img>
        </header>
     );
}

export default Banner;